import React from 'react'
import {Link} from "gatsby";
import HeroImage from "../HeroImage";
import Question from "../Question";


const SaJooAds: React.FC = () => (
    <div className={'container max-w-screen-lg mx-auto sm:flex sm:justify-between my-8 border-2 py-4'}>
        <div className="w-full sm:w-1/2 text-center flex justify-center items-center">
            <div className="w-64">
                <Question/>
            </div>
        </div>
        <div className="text-center md:text-left sm:w-1/2">
            <h2 className="text-base lg:text-lg xl:text-xl font-bold leading-none">
                당신의 사주도 궁금하지 않으신가요?
            </h2>
            <p className="text-sm mt-1 font-light">
                전문 사주풀이 엔진이 분석하는 온라인 사주풀이를 이용해보세요!
            </p>
            <div className="mt-8 md:mt-2 flex flex-col items-center">
                <Link to={'/sajoo'}>
                    <button
                        className="block mx-auto mb-2 sm:inline-block w-64 py-2 sm:py-3 px-3 sm:mr-4 bg-blue-400 hover:bg-blue-500 rounded text-white">
                        내 사주 풀러 가기
                    </button>
                </Link>
                <p className="text-xs mt-1 text-gray-600 font-thin">
                    사주풀이 서비스는 유료입니다.
                </p>
            </div>

        </div>

    </div>
)

export default SaJooAds